/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFLocale } from './CRSFLocale';
import {
    CRSFLocaleFromJSON,
    CRSFLocaleFromJSONTyped,
    CRSFLocaleToJSON,
} from './CRSFLocale';
import type { Metrics } from './Metrics';
import {
    MetricsFromJSON,
    MetricsFromJSONTyped,
    MetricsToJSON,
} from './Metrics';

/**
 * 
 * @export
 * @interface CRSFTriggerNoIssueResponse
 */
export interface CRSFTriggerNoIssueResponse {
    /**
     * 
     * @type {string}
     * @memberof CRSFTriggerNoIssueResponse
     */
    cobranded?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFTriggerNoIssueResponse
     */
    domains: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CRSFTriggerNoIssueResponse
     */
    entity_name?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CRSFTriggerNoIssueResponse
     */
    extra?: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof CRSFTriggerNoIssueResponse
     */
    force?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFTriggerNoIssueResponse
     */
    ip_addresses?: Array<string>;
    /**
     * 
     * @type {CRSFLocale}
     * @memberof CRSFTriggerNoIssueResponse
     */
    locale?: CRSFLocale;
    /**
     * 
     * @type {{ [key: string]: Metrics; }}
     * @memberof CRSFTriggerNoIssueResponse
     */
    metrics?: { [key: string]: Metrics; };
    /**
     * 
     * @type {string}
     * @memberof CRSFTriggerNoIssueResponse
     */
    process_id: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFTriggerNoIssueResponse
     */
    request_origin?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFTriggerNoIssueResponse
     */
    scan_web_sev2_force?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CRSFTriggerNoIssueResponse
     */
    user?: string;
}

/**
 * Check if a given object implements the CRSFTriggerNoIssueResponse interface.
 */
export function instanceOfCRSFTriggerNoIssueResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "domains" in value;
    isInstance = isInstance && "process_id" in value;

    return isInstance;
}

export function CRSFTriggerNoIssueResponseFromJSON(json: any): CRSFTriggerNoIssueResponse {
    return CRSFTriggerNoIssueResponseFromJSONTyped(json, false);
}

export function CRSFTriggerNoIssueResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFTriggerNoIssueResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cobranded': !exists(json, 'cobranded') ? undefined : json['cobranded'],
        'domains': json['domains'],
        'entity_name': !exists(json, 'entity_name') ? undefined : json['entity_name'],
        'extra': !exists(json, 'extra') ? undefined : json['extra'],
        'force': !exists(json, 'force') ? undefined : json['force'],
        'ip_addresses': !exists(json, 'ip_addresses') ? undefined : json['ip_addresses'],
        'locale': !exists(json, 'locale') ? undefined : CRSFLocaleFromJSON(json['locale']),
        'metrics': !exists(json, 'metrics') ? undefined : (mapValues(json['metrics'], MetricsFromJSON)),
        'process_id': json['process_id'],
        'request_origin': !exists(json, 'request_origin') ? undefined : json['request_origin'],
        'scan_web_sev2_force': !exists(json, 'scan_web_sev2_force') ? undefined : json['scan_web_sev2_force'],
        'user': !exists(json, 'user') ? undefined : json['user'],
    };
}

export function CRSFTriggerNoIssueResponseToJSON(value?: CRSFTriggerNoIssueResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cobranded': value.cobranded,
        'domains': value.domains,
        'entity_name': value.entity_name,
        'extra': value.extra,
        'force': value.force,
        'ip_addresses': value.ip_addresses,
        'locale': CRSFLocaleToJSON(value.locale),
        'metrics': value.metrics === undefined ? undefined : (mapValues(value.metrics, MetricsToJSON)),
        'process_id': value.process_id,
        'request_origin': value.request_origin,
        'scan_web_sev2_force': value.scan_web_sev2_force,
        'user': value.user,
    };
}

